<template>

    <footer style="height: auto; padding-top:2px;">

        <v-card class="footer semi-transparent-7-bg" flat tile height="auto">

            <v-card-text class="justify-center" style="display: flex;">

                <div v-for="(contact, i) in contacts" :key="i" :index="i">

                    <img class="v-image__image--cover" style="cursor: pointer; padding: 2px;" :src="getImgUrl(contact)" width="70" height="auto" @click.prevent="$router.push({name: 'Contact'})"/>

                </div>

            </v-card-text>

        </v-card>

    </footer>

</template>

<script>
export default {
    name: 'pageFooter',
    data() {
        return {
            contacts: [
                "facebook",
                "twitter",
                "instagram",
                "whatsapp",
            ]
        }
    },
    methods: {
        getImgUrl(item) {

            var images = require.context('@/assets/contact/footer', false, /\.jpg$/);

            return images('./' + item + ".jpg");

        }
    }
}
</script>

<style scoped>

    .v-image__image, .v-image__placeholder {
        width: 100px;
        height: 25px;
    }

    .v-card__text {
        padding-bottom: 0px;
        padding-top: 1px;
        width: 100%;
    }

    .footer {
        width: 100%;
        padding: 10px;
        border-top: 2px solid #616164;
    }

</style>
